/**
 * Formats a number with commas as thousand separators
 * @param value - The number to format (or undefined which will be treated as 0)
 * @returns Formatted string with commas (e.g., 1000 -> "1,000")
 */
export const formatNumber = (value: number | undefined): string => {
  return (value || 0).toLocaleString('en-US');
};
